import { testFeature } from '@opallabs/principles'

/**
 * Whether Month draws the React calendar instead of the Marionette one.
 *
 * Read from the flags the server writes onto the page rather than from the API,
 * because the answer is needed on the first render: the shell asks Backbone to
 * draw the Marionette month as soon as this says no, and an answer that arrives
 * later would leave that month running underneath the React one.
 *
 * While this is off the calendar behaves exactly as it always has: the shell
 * renders an empty mount point and Backbone fills it.
 */
export const useReactMonthView = (): boolean => testFeature('react_month_view')
